import { Flex, TextProps } from '@chakra-ui/react';
import { HoverCard } from '@texas/components/shared/HoverCard';
import { Icons } from '@texas/components/shared/Icons';
import { CompositionGroupHoverCard } from '@texas/components/shared/hovercards/CompositionGroupHoverCard';
import { CompositionGroupTitle } from './CompositionGroupTitle';

type GroupType = 'version' | 'option';

interface Props extends TextProps {
  compositionGroupId?: number | null;
  version: number;
  option?: number | null;
  note: string | null;
  type: GroupType;
  linkedVariantId?: number | null;
}

export function CompositionGroupTitleWithHover({
  compositionGroupId,
  ...props
}: Props) {
  const title = <CompositionGroupTitle {...props} />;

  if (!compositionGroupId) return title;

  return (
    <HoverCard
      placement="right-start"
      fallbackPlacements={['left-start', 'right-start']}
      content={
        <CompositionGroupHoverCard compositionGroupId={compositionGroupId} />
      }
    >
      <Flex
        as="span"
        display="inline-flex"
        align="center"
        gap={1}
        cursor="help"
      >
        {title}
        <Icons.InformationOutline boxSize={3} color="gray.400" flexShrink={0} />
      </Flex>
    </HoverCard>
  );
}
